import state from './module-organization-transfer-state';
import mutations from './module-organization-transfer-mutations';
import actions from './module-organization-transfer-actions';
import getters from './module-organization-transfer-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
